import axios, { AxiosResponse } from "axios";
import { GroupItem, Item } from "BrokerTsLib/src/dtos";
import { longStaleTime } from "BrokerTsLib/src/hooks";
import { UseQueryResult, useQuery } from "react-query";
import { GenericQueryOptions, useUrl } from ".";


export const useGetRisks = (options?: GenericQueryOptions<GroupItem[]>): UseQueryResult<AxiosResponse<GroupItem[], any>, any> => {
    const url = useUrl()

    return useQuery(['GetRisks', 'travel'], () =>
        axios.get<Item[]>(`${url}/GetRisks`), { staleTime: longStaleTime, ...options })
}

export const useGetGroupedRisks = () => {
    const { data } = useGetRisks({ refetchOnWindowFocus: false, refetchOnMount: false })

    return data?.data.reduce((pv, cv) => {
        return { ...pv, [cv.groupId ?? '']: [...(pv[cv.groupId ?? ''] ?? []), cv] }
    }, {} as { [n: string]: GroupItem[] })
}